import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {

  transform(value: number): string {
    let formattedValue: string;

    if (Math.abs(value) >= 100000) {
      // Format for lakhs
      formattedValue = (value / 100000).toFixed(2);
      return this.trimTrailingZeros(formattedValue) + 'L';
    } else if (Math.abs(value) >= 1000) {
      // Format for thousands
      formattedValue = (value / 1000).toFixed(2);
      return this.trimTrailingZeros(formattedValue) + 'k';
    }

    return value.toString(); // Return the original value if less than 1000
  }
  
  private trimTrailingZeros(value: string): string {
    return value.replace(/\.00$/, '').replace(/(\.\d*?)0+$/, '$1');
  }

}
